import firebase from "firebase";
import axios from "axios";
import {storage} from "../../firebase";

//helper function to log the data completed once student has finished every question in the assignment
//Checks every time the student finishes a question in the assignment
export function UpdateCompletionDate(indexNum, classLevel, assignmentCompletion){
    let count = 0;
    let update = false;

    //Quickly checks if assignment is completed
    for(let i = 0; i < assignmentCompletion.length; i++){
        if(assignmentCompletion[i] === 1){
            count += 1
        }
    }
    if(count/assignmentCompletion.length*100 !== 100){
        //return other wise
        return;
    }

    //If assignment IS completed, run the promise to log the data
    let promise = new Promise((resolve => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {

                //Making correct date
                let date = new Date();
                let AMPM = "AM";
                if(date.getHours() >= 12){
                    AMPM = "PM";
                }
                let hours = date.getHours();
                if (hours >= 12) {
                    hours -= 12;
                }
                if (hours == 0) {
                    hours = 12;
                }
                let newDate = date.getMonth() + '/' + date.getDate() + '/' + date.getFullYear() + ' ' + hours + ':' + date.getMinutes() + AMPM;
                let email = user.email;
                let studentDataIndex;

                //Get the student data file for quizzes
                const studentFile = firebase.storage().ref().child('students/10' + classLevel + '/quizData.json');
                studentFile.getDownloadURL()
                    .then(url => axios.get(url))
                    .then(res => {
                        let studentData = res.data;
                        for (let i = 0; i < studentData.length; i++) {

                            //find the correct student and save the index
                            if (studentData[i].email === email) {
                                if(studentData[i].date[indexNum] === ''){
                                    studentData[i].date[indexNum] = newDate;
                                    update = true;
                                    break;
                                }
                            }
                        }

                        //Update = true means the student email was found so, update the student quiz file
                        if(update){
                            const JSONobj = JSON.stringify(studentData);
                            const blobObj = new Blob([JSONobj], {type: "application/json"});
                            const uploadTask = storage.ref('students/10' + classLevel + '/quizData.json').put(blobObj);
                            uploadTask.on(
                                "state_changed",
                                () => {
                                },
                                error => {
                                    console.log(error)
                                },
                                () => {
                                    storage
                                        .ref("students/10" + classLevel)
                                        .child('quizData.json')
                                        .getDownloadURL()
                                        .then(url => {
                                                console.log(url);
                                                resolve('completed')
                                            }
                                        )
                                        .catch(e => console.log(e));
                                }
                            )
                        }

                    });


            }
        });
    }))
    return promise;
}
